export default "__VITE_ASSET__DcQItyPH__"